/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setSplash } from "./setSplash";
import { setDNavBtn } from "./setDNavBtn";
import { setScrollTrigger } from "./setScrollTrigger";
import { setFloorPlan } from "./add/setFloorPlan";
import { scrollToTopBtn } from "./smoothScrollToTopBtn";
import { setMvPageNavMouseStalker } from "./add/setMvPageNav";
import { setLightbox } from "./add/setLightbox";
import { setGMenuHoverAction } from "./add/gMenuHoverAction";
import { tabSelecterClick } from "./setTabSelecter";
import { setPinLength } from "./add/setPinLength";
import { setAcdnMenu } from "./setAcdnMenu";
import { setModal } from "./setModal";
import "./add/setNavMenu";
import "./setSlider";

/**
 * Do modules.
 */
function modules() {
  setDNavBtn();
  setScrollTrigger();
  setSplash();
  setFloorPlan();
  scrollToTopBtn();
  setMvPageNavMouseStalker();
  setLightbox();
  setGMenuHoverAction();
  tabSelecterClick();
  setPinLength();
  setAcdnMenu();
  setModal();
}

export { modules };
